import { combineReducers } from 'redux-immutable';
import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { reducer as formReducer } from 'redux-form/immutable';
import Immutable from 'immutable';
import { routerMiddleware } from 'react-router-redux';
import { apiMiddleware } from 'redux-api-middleware';
import moduleReducers from './reducers';
import ApiClient from './ApiClient';
import gaPageViewTrackingMiddleware from './gaPageViewTrackingMiddleware';
import routerReducer from './reactRouterReducer';

const api = new ApiClient();

export default function configureStore(history, preLoadedState) {
  const middlewares = [
    thunkMiddleware.withExtraArgument(api),
    // clientMiddleware(api),
    apiMiddleware,
    routerMiddleware(history),
    gaPageViewTrackingMiddleware
  ];

  if (process.env.NODE_ENV !== 'production') {
    if (!window.devToolsExtension) {
      const { logger } = require('redux-logger');
      // middlewares.push(logger);
    }
  }

  const enhancer = compose(
    applyMiddleware(...middlewares),
    // other store enhancers if any,
    window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f,
    window.devToolsExtension ? window.devToolsExtension({
      name: 'VideoPeel', actionsBlacklist: ['REDUX_STORAGE_SAVE']
    }) : noop => noop
  );

  const reducers = combineReducers({
    router: routerReducer,
    form: formReducer,
    ...moduleReducers
  });

  const initialState = Immutable.fromJS(preLoadedState || {});
  return createStore(reducers, initialState, enhancer);
}



// WEBPACK FOOTER //
// ./src/redux/createStore.js